import { Lookup } from '../../../shared-components/lookup/lookup.model';
import { BehaviorActionCode } from '../models/behavior-action-code.model';

export class BehaviorEventsFilterParam {
  eventDateFrom: Date;
  eventDateTo: Date;
  actionDateFrom: Date;
  actionDateTo: Date;
  incidentCode: Lookup;
  actionCode: BehaviorActionCode;
  reportedToState: boolean;
  onlyShowSuspensions: boolean;
  location: Lookup;
  offender?: string;
  victim?: string;
  comment?: string;
  incidentApproveAction = false;
}

export class BehaviorEventsSearchFilter {
  fromDate: Date;
  toDate: Date;
  lastName: string;
  firstName: string;
  eventNumber: number;
  studentNumber: string;
}
